import { render, staticRenderFns } from "./DesktopOnly.vue?vue&type=template&id=6da945b5&scoped=true&"
import script from "./DesktopOnly.vue?vue&type=script&lang=ts&"
export * from "./DesktopOnly.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopOnly.vue?vue&type=style&index=0&id=6da945b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da945b5",
  null
  
)

export default component.exports